import React from 'react';
import { DataList } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs } from './listConfig';

const ConfigUpdateList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getKeyValue } = useService();
	return (
		<DataList
			fetchData={getKeyValue}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			rowHeight={100}
			entity={LIST_ENTITY_NAMES.zkDashBoardUpdate}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default ConfigUpdateList;
